// eslint-disable-next-line @typescript-eslint/naming-convention
export enum ALERT_TYPE {
  error = 'error',
  info = 'info',
  success = 'success',
  warning = 'warning',
  download = 'download',
  processing = 'processing',
}
